import { HTMLProps } from "react";
import clsx from "clsx";

import { ArrowRight } from "../Icons";

const AnchorWrapper = ({ children, ...rest }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className="flex flex-col w-screen p-4 md:w-full" {...rest}>
      {children}
    </div>
  );
};

const AnchorBody = ({ children, ...rest }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className="flex flex-col gap-4 md:flex-row" {...rest}>
      {children}
    </div>
  );
};

const AnchorHeader = ({ children, ...rest }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className="flex flex-col mb-4 border-b-2 cursor-pointer border-neutral-50" {...rest}>
      {children}
    </div>
  );
};

const AnchorTitle = ({ children, ...rest }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className="flex flex-row items-center gap-1 mb-1 font-bold text-platform-700 text-md" {...rest}>
      {children} <ArrowRight />
    </div>
  );
};
const AnchorSubtitle = ({ children, ...rest }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className="mb-2 text-sm text-neutral-500" {...rest}>
      {children}
    </div>
  );
};

const AnchorColumn = ({ children, ...rest }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className="flex flex-col gap-4 p-4 rounded-sm bg-neutral-50 grow lg:min-w-80" {...rest}>
      {children}
    </div>
  );
};

const AnchorColumnTitle = ({ children, className, ...rest }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className={clsx("flex flex-col bg-neutral-50 font-bold", className)} {...rest}>
      {children}
    </div>
  );
};

export const Anchor = {
  Wrapper: AnchorWrapper,
  Header: AnchorHeader,
  Title: AnchorTitle,
  Subtitle: AnchorSubtitle,
  Body: AnchorBody,
  Column: AnchorColumn,
  ColumnTitle: AnchorColumnTitle,
};
